import React, { Component } from "react";
import { find, sumBy } from "lodash";
import { CurrencyFormatter } from "../chartHelper";
import Slider from "react-slick/lib";

export default class ChartsDetails extends Component {
  render() {
    const {
      openProjectsByImplementationMode: {
        projectImplementationModeCountDTOList,
        totalActiveProjects: openProject
      },
      projectsStatusWithRespectToIssue: {
        projectStatusCountDTOS,
        totalActiveProjects: totalProject
      },
      isDesktopView
    } = this.props;

    let resolved = find(projectStatusCountDTOS, [
      "projectStatusWithRespectToIssueStatus",
      "RESOLVED"
    ]);
    let open = find(projectStatusCountDTOS, [
      "projectStatusWithRespectToIssueStatus",
      "OPEN"
    ]);
    let _private = find(projectImplementationModeCountDTOList, [
      "implementationMode",
      "PRIVATE"
    ]);
    let _public = find(projectImplementationModeCountDTOList, [
      "implementationMode",
      "PUBLIC"
    ]);
    let ppp = find(projectImplementationModeCountDTOList, [
      "implementationMode",
      "PPP"
    ]);

    let test = (
      <React.Fragment>
        <div className="detail-box resolution-status-box">
          <div className="top-section">Resolution Status</div>
          <div className="middle-section">
            <div className="total-box">
              {totalProject}
              <span>UNDER CONSTRUCTION / UNDER IMPLEMENTATION</span>
            </div>
            <div className="sub-boxes">
              <div className="sub-box-one">
                {resolved && resolved.count}
                <span>RESOLVED</span>
              </div>
              <div className="sub-box-two">
                {open && open.count}
                <span>OPEN</span>
              </div>
            </div>
          </div>
          <div className="last-section">
            <p>
              *Status breakup for resolved (where all issues are resolved) and
              open (where issue resolution is pending under PMG mechanism)
              projects.
            </p>
          </div>
        </div>

        <div className="detail-box under-consideration-box">
          <div className="top-section">Under Consideration</div>
          <div className="middle-section">
            <div className="total-box">
              {openProject}
              <span>OPEN PROJECTS</span>
            </div>
            <div className="sub-boxes">
              <div className="sub-box-one">
                {_public && _public.count}
                <span>PUBLIC</span>
              </div>
              <div className="sub-box-three">
                {_private && _private.count}
                <span>PRIVATE</span>
              </div>
              <div className="sub-box-two">
                {ppp && ppp.count}
                <span>PPP</span>
              </div>
            </div>
          </div>
          <div className="last-section">
            <p>
              *Implementation mode within {openProject} projects pending for
              issue resolution under PMG mechanism
            </p>
          </div>
        </div>
      </React.Fragment>
    );

    let settings = {
      dots: true,
      infinite: true,
      speed: 100,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      autoplay: false
      //autoplaySpeed:3000
    };

    return isDesktopView ? (
      <div className="dashboard-charts-detail-box second-page">{test}</div>
    ) : (
      <div className="dashboard-charts-detail-box second-page">
        <Slider {...settings}>
          <div className="detail-box resolution-status-box">
            <div className="top-section">Resolution Status</div>
            <div className="middle-section">
              <div className="total-box">
                {totalProject}
                <span>UNDER CONSTRUCTION / UNDER IMPLEMENTATION</span>
              </div>
              <div className="sub-boxes">
                <div className="sub-box-one">
                  {resolved && resolved.count}
                  <span>RESOLVED</span>
                </div>
                <div className="sub-box-two">
                  {open && open.count}
                  <span>OPEN</span>
                </div>
              </div>
            </div>
            <div className="last-section">
              <p>
                *Status breakup for resolved (where all issues are resolved) and
                open (where issue resolution is pending under PMG mechanism)
                projects.
              </p>
            </div>
          </div>

          <div className="detail-box under-consideration-box">
            <div className="top-section">Under Consideration</div>
            <div className="middle-section">
              <div className="total-box">
                {openProject}
                <span>OPEN PROJECTS</span>
              </div>
              <div className="sub-boxes">
                <div className="sub-box-one">
                  {_public && _public.count}
                  <span>PUBLIC</span>
                </div>
                <div className="sub-box-three">
                  {_private && _private.count}
                  <span>PRIVATE</span>
                </div>
                <div className="sub-box-two">
                  {ppp && ppp.count}
                  <span>PPP</span>
                </div>
              </div>
            </div>
            <div className="last-section">
              <p>
                *Implementation mode within {openProject} projects pending for
                issue resolution under PMG mechanism
              </p>
            </div>
          </div>
        </Slider>
      </div>
    );
  }
}
